import { gql } from "@apollo/client";

import type {
  BrandFragment,
  ProductFragment,
  VariantFragment,
  WholesalePromotionDetailsFragment,
} from "@shared/data/fragments";
import type { Category } from "@shared/types/graphqlGenerated";

const CATALOG_PRODUCT_MASTER_VARIANT_CLINIC = gql`
  fragment CatalogProductMasterVariantClinic on Product {
    id
    _legacyId
    name
    description
    variantCount
    storeAllowedWholesale
    brand {
      id
      name
    }
    availableOrMasterVariant {
      id
      availabilityStatus
      descriptor
      expectedReturnDate
      image
      imageNew
      msrp
      sku
      variantType
      name
      sellPrice
      wholesale
      wholesalePrice
      wholesalePromotionDetails {
        price
        percentageOff
      }
    }
    categories {
      nodes {
        id
      }
    }
  }
`;

type VariantSplinter = Pick<
  VariantFragment,
  | "id"
  | "availabilityStatus"
  | "descriptor"
  | "image"
  | "imageNew"
  | "msrp"
  | "name"
  | "sellPrice"
  | "wholesale"
  | "wholesalePrice"
  | "isAvailableForPurchase"
  | "sku"
  | "variantType"
>;

type PromotionsSplinter = Pick<WholesalePromotionDetailsFragment, "price" | "percentageOff">;

type BrandSplinter = Pick<BrandFragment, "id" | "name">;

type ProductSplinter = Pick<
  ProductFragment,
  "id" | "_legacyId" | "description" | "name" | "storeAllowedWholesale" | "variantCount"
>;

type CategorySplinter = Pick<Category, "id">;

interface MasterVariant extends VariantSplinter {
  wholesalePromotionDetails: PromotionsSplinter;
}

interface CatalogProductMasterVariantClinic extends ProductSplinter {
  brand: BrandSplinter;
  categories: {
    nodes: CategorySplinter[];
  };
  availableOrMasterVariant: MasterVariant;
}

export type { CatalogProductMasterVariantClinic };
export { CATALOG_PRODUCT_MASTER_VARIANT_CLINIC };
